import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global Lenis smooth-scroll wrapper.
 * - Respects prefers-reduced-motion (skips smoothing entirely).
 * - Exposes the instance on window for section-level anchor scrolling.
 * - Cleans up on unmount.
 */
export default function SmoothScroll({ children }) {
  useEffect(() => {
    const reduce =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.0,
      touchMultiplier: 1.2,
    });
    window.__lenis = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return <div style={{ position: "relative" }}>{children}</div>;
}
